module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 106 36",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }